<template>
  <div
    v-if="availableResources.includes(resource.name)"
    :class="`image_${resource.name}`"
  />
</template>

<script>
import config from '@/config';

export default {
  name: 'ResourceImage',
  props: ['resource'],
  computed: {
    availableResources() {
      return config.availableResources;
    },
  },
};
</script>

<style scoped lang="scss">
.image_ball {
  mask: url('../assets/ball.svg') no-repeat;
}

.image_stool {
  mask: url('../assets/stool.svg') no-repeat;
}

.image_mat {
  mask: url('../assets/mat.svg') no-repeat;
}

.image_stepper {
  mask: url('../assets/stepper.svg') no-repeat;
}

.image_towel {
  mask: url('../assets/towel.svg') no-repeat;
}
</style>



// WEBPACK FOOTER //
// src/elements/ResourceImage.vue